<template>
  <div class="aboutus_box">
    <div class="banner">
      <img src="../../assets/images/videobg.jpg" alt="">
      <!-- <iframe
        src="https://www.youtube.com/embed/P93tsrvPOGU"
        width="100%" 
        height="500" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
      ></iframe> -->
      <!-- <div class="content">
        <div class="leftvideo">
          <qplayer ref="qplayer" v-bind:fileId="curFileID" width="400" height="300"></qplayer>
        </div>
        <div class="rightvideo">
          <div class="threevideo" @click="changeFildId(0)"><img src="../../assets/images/video22.png" alt=""><p>GASA 2018 Silicon Valley Session</p></div>
          <div class="threevideo" @click="changeFildId(1)"><img src="../../assets/images/video21.png" alt=""><p>GASA 2018 Israel Session </p></div>
          <div class="threevideo" @click="changeFildId(2)"><img src="../../assets/images/video23.png" alt=""><p>GASA 2017 Silicon Valley Session</p></div>
          <div class="threevideo" @click="changeFildId(3)"><img src="http://1257036669.vod2.myqcloud.com/9e668b37vodtranscq1257036669/fae1b4725285890809908920272/coverBySnapshot_10_0.jpg" alt=""><p>Documentary of GASA 2019 UK Session </p></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "video.page.less";
</style>

<script>
import qPlayer from '@/components/qPlayer.vue'
export default {
  name: 'VideoPage',
  data () {
    return {
      fildIdarr: ['5285890809975080336', '5285890809975080337', '5285890809974814049', '5285890809908920272'],
      curFileID: '5285890809975080336',
      fileIndex: 0
    }
  },
  mounted () {
    // this.$refs.qplayer.initPlayer()
  },
  created () {
    this.curFileID = this.$route.params.videoId
  },
  methods: {
    changeFildId: function (n) {
      this.fileIndex = n
      this.curFileID = this.fildIdarr[n]
      this.$router.push({name: 'video', params: { videoId: this.curFileID }})
      // console.log(this.curFileID)
    }
  },
  components: {
    qplayer: qPlayer
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/video/video.page.vue